export default "__VITE_ASSET__DE15HPkq__ 778w";